module.exports = __webpack_public_path__ + "img/20-2-p1.922cb9ae.png";